<template>
  <xui-carousel arrow="always" :height="bannerHeight + 'px'" :interval="10000">
    <xui-carousel-item v-for="(it, index) in banner" :key="it.title">
      <xui-row>
        <xui-col :span="24" class="img-wrap">
          <a :href="it.url">
            <img ref="bannerHeight" :src="it.logoUrl" :alt="it.title" @load="imgLoad" class="img-detail" />
          </a>
          <div class="carousel-item-info">
              <router-link v-if="index === 0" class="carousel__link" to="report"><span> 提交漏洞</span></router-link>
            <!-- <h3>{{it.title}}</h3>  -->
            <!-- <button type="button" class="xui-button read-more xui-button--primary" @click="open(it.url)">
                                <span>了解更多</span>
                            </button> -->
          </div>
        </xui-col>
      </xui-row>
    </xui-carousel-item>
  </xui-carousel>
</template>

<script>
export default {
  name: 'Banner',
  data: function() {
    return {
      banner: [],
      bannerHeight: ''
    };
  },
  mounted() {
    this.imgLoad();
    window.addEventListener(
      'resize',
      () => {
        this.imgLoad();
      },
      false
    );
    this.queryBannerList();
  },
  methods: {
    queryBannerList: function() {
      let s = new Promise((resolve, reject) => {
        this.$http
          .get('vul/hsrc/vul/report/services/banner/list')
          .then(res => {
            if (res.data && res.status === 200) {
              this.banner = res.data.data;
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    open: function(url) {
      window.location.href = url;
    },
    imgLoad() {
      this.$nextTick(() => {
        let ref = this.$refs;
        setTimeout(() => {
          this.bannerHeight = ref.bannerHeight && ref.bannerHeight.length ? ref.bannerHeight[0].height : '';
        }, 100)
      });
    }
  }
};
</script>

<style lang="less" scoped>

/deep/.xui-carousel__container,
.xui-carousel {
  overflow: hidden;
}

/deep/ .xui-button--primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  background-image: none;
  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
  }
}
/deep/ .xui-button {
  background-image: none;
  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
  }
}
/deep/ .carousel-item-info {
  position: absolute;
  top: 68%;
  left: 44%;
  width: 40%;
  z-index: 1000;
  h3 {
    display: inline-block;
    color: #fff;
    font-size: 1.8rem;
    width: 100%;
    margin: 0 0 2.5rem 0;
    font-weight: normal;
  }
}
.img-wrap.xui-col {
  padding-bottom: 32.8%;
  width: 100%;
  position: relative;
  .img-detail {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.carousel__link{
  height: 60px;
  line-height:58px;
  padding: 0 50px;
  border: 1px solid var(--src-text-color-secondary);
  border-radius: 4px;
  background-color:rgba(59, 149, 185, 0.2);
  font-size: var(--src--text-size-large-extra2);
  color: var(--src-color-secondary-light8);
}
</style>



// WEBPACK FOOTER //
// src/views/home/Banner.vue